// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__XtVRH","containerItemsCenter":"Skeleton_containerItemsCenter__2ari9"};